import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@src/service';
import type {
  IAnalyticsMetricsResponse,
  IAnalyticsChartsResponse,
  IGetAnalyticsChartsParams,
} from './types';

export const analyticsFeatureApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'analyticsFeatureApi',
  tagTypes: ['AnalyticsMetrics', 'AnalyticsCharts'],
  endpoints: (builder) => ({
    getAnalyticsMetrics: builder.query<IAnalyticsMetricsResponse, void>({
      query: () => ({
        url: '/api/v1/analytics/metrics',
        method: 'GET',
      }),
      providesTags: ['AnalyticsMetrics'],
    }),
    getAnalyticsCharts: builder.query<IAnalyticsChartsResponse, IGetAnalyticsChartsParams | void>({
      query: (params) => {
        const aggregation = params?.aggregation ?? 'DAILY';
        const queryParams: Record<string, string | number> = { aggregation };
        if (params?.year != null) queryParams.year = params.year;
        if (params?.week != null) queryParams.week = params.week;
        if (params?.startDate) queryParams.startDate = params.startDate;
        if (params?.endDate) queryParams.endDate = params.endDate;
        return {
          url: '/api/v1/analytics/charts',
          method: 'GET',
          params: queryParams,
        };
      },
      providesTags: ['AnalyticsCharts'],
    }),
  }),
});

export const { useGetAnalyticsMetricsQuery, useGetAnalyticsChartsQuery } = analyticsFeatureApi;
